export const en = {
  appTagline: 'Open live flight tracker',
  search: 'Search flight, registration, hex or airport',
  searchNoResults: 'Nothing found nearby or upstream.',
  searchUpstream: 'Searching the network…',
  filters: 'Filters',
  layers: 'Map',
  settings: 'Settings',
  about: 'About & data',
  close: 'Close',
  aircraft: 'Aircraft',
  inView: 'in view',
  ground: 'Ground',
  altitude: 'Altitude',
  geoAltitude: 'GPS altitude',
  speed: 'Ground speed',
  vs: 'Vertical rate',
  track: 'Track',
  squawk: 'Squawk',
  registration: 'Registration',
  type: 'Type',
  category: 'Category',
  hex: 'ICAO 24-bit',
  source: 'Position source',
  positionAge: 'Position age',
  provider: 'Data provider',
  route: 'Route',
  routeUnknown: 'No route on record for this callsign.',
  routeImplausible: 'A route is on record for this callsign but doesn’t match where the aircraft is now, so it’s hidden.',
  routeNote: 'Usual route for this callsign (community data). Not a live schedule.',
  follow: 'Follow',
  unfollow: 'Stop following',
  share: 'Copy link',
  copied: 'Link copied',
  trail: 'Trail shows positions received since you started watching.',
  emergency: 'Emergency',
  military: 'Military',
  noCallsign: 'No callsign',
  zoomIn: 'Zoom in to load aircraft for this whole area. Showing the centre only.',
  stale: 'Live data delayed: the community network is throttling or unavailable. Showing the last known positions.',
  offline: 'You’re offline. Positions will resume when the connection returns.',
  loading: 'Loading live aircraft…',
  errorData: 'Couldn’t reach the Skywake API.',
  apiNotConfigured: 'This build has no live-data API configured, so no aircraft can be shown.',
  retry: 'Retry',
  dataAge: 'Data age',
  providerStatus: 'Provider status',
  ok: 'OK',
  degraded: 'Degraded',
  theme: 'Theme',
  themeAuto: 'System',
  themeLight: 'Light',
  themeDark: 'Dark',
  units: 'Units',
  language: 'Language',
  labels: 'Callsign labels',
  airports: 'Airports',
  trails: 'Trail for selected aircraft',
  colorBy: 'Colour aircraft by',
  colorAlt: 'Altitude',
  colorSource: 'Position source',
  altMin: 'Min altitude (ft)',
  altMax: 'Max altitude (ft)',
  speedMin: 'Min speed (kt)',
  speedMax: 'Max speed (kt)',
  callsignPrefixes: 'Airline / callsign prefixes',
  callsignPrefixesHint: 'Comma separated, e.g. ROT, WZZ, RYR',
  types: 'Aircraft types',
  typesHint: 'ICAO codes, * as wildcard, e.g. A32*, B738',
  hideGround: 'Hide aircraft on the ground',
  onlyEmergency: 'Only emergencies (7500/7600/7700)',
  onlyMilitary: 'Only military',
  sources: 'Position sources',
  presets: 'Saved presets',
  presetName: 'Preset name',
  savePreset: 'Save current filters',
  apply: 'Apply',
  delete: 'Delete',
  clearFilters: 'Clear filters',
  filtered: 'filtered',
  airport: 'Airport',
  elevation: 'Elevation',
  nearbyTraffic: 'Traffic within 30 km',
  noNearby: 'No tracked aircraft near this airport right now.',
  viewOnOurAirports: 'View on OurAirports',
  bookmarks: 'Bookmarks',
  bookmarkView: 'Bookmark this view',
  watchlist: 'Watch',
  watching: 'Watching',
  alerts: 'Alerts',
  alertsEmergency: 'Notify me about emergency squawks in view',
  alertsWatch: 'Notify me when watched aircraft appear',
  alertsPermissionDenied: 'Notifications are blocked by your browser. Alerts will show inside the app only.',
  emergencyAlert: 'Emergency squawk',
  watchAlert: 'Watched aircraft spotted',
  adsb: 'ADS-B',
  mlat: 'MLAT',
  tisb: 'TIS-B',
  adsr: 'ADS-R',
  modes: 'Mode S',
  other: 'Other',
  attribution: 'Aircraft data: ADSB.lol contributors (ODbL 1.0). Routes: VRS standing data (CC0). Airports: OurAirports (public domain). Photos: Planespotters.net photographers (credited on each photo). Weather: NOAA Aviation Weather Center (public domain).',
  aboutBody:
    'Skywake is free, open-source software. Positions come from volunteer ADS-B receivers aggregated by ADSB.lol, and coverage depends on where volunteers run receivers. There are no accounts, no ads and no tracking cookies. Your settings stay on this device.',
  limitations: 'Known limitations',
  limitationsList:
    'No flight history or replay yet: Skywake only shows what it has received since you opened it.|Routes come from a community callsign database and can be wrong or outdated.|Coverage is thin over oceans and in regions with few volunteer receivers.|Aircraft whose owners asked for privacy (e.g. LADD/PIA) may be hidden or anonymised upstream.',
  sourceCode: 'Source code',
  feedData: 'Run a receiver and feed ADSB.lol',
  version: 'Version',
  webglMissing: 'Your browser can’t draw the live map (WebGL2 is unavailable).',
  selectedOutOfCoverage: 'This aircraft is no longer being received.',
  emergencies: 'Emergencies',
  compare: 'Compare',
  list: 'List',
  sortBy: 'Sort by',
  callsign: 'Callsign',
  locate: 'My location',
  photoAlt: 'Photo of aircraft {reg}',
  weather: 'Weather (METAR)',
  weatherUnavailable: 'Weather is unavailable right now.',
  weatherNone: 'This airport publishes no METAR.',
  weatherSource: 'NOAA Aviation Weather Center. Not for flight planning.',
  wind: 'Wind',
  calm: 'Calm',
  variable: 'Variable',
  gusts: 'gusts',
  visibility: 'Visibility',
  temperature: 'Temp / dew point',
  clouds: 'Clouds',
  observed: 'Report age',
  legFlown: 'flown',
  legToGo: 'to go',
  legEta: 'Arrival',
  legNote: 'Great-circle estimate from the usual route and the current ground speed.',
};

export type MsgKey = keyof typeof en;
export type Dict = Record<MsgKey, string>;
